/**
 * 管理画面 (vendor/adminlte/master) のエントリ。
 * jQuery / Bootstrap 5 / AdminLTE 4 / bootbox をグローバルへ載せたうえで、
 * 管理画面共通の処理を読み込む (#390)。
 *
 * AdminLTE 4 は jQuery プラグインではなく素の JS で、Bootstrap 5 を
 * peerDependency にしている。AdminLTE 3 のときに必要だった Bootstrap 4 の
 * 読み込み (bootstrap4.js) はこの移行で不要になり、公開画面・地図画面と
 * 同じ Bootstrap 5 を共有する。
 */

// jQuery → Bootstrap 5 の順にグローバルを整える (bootstrap.js 参照)。
// jQuery 自体は select2 / bootbox / Blade のインラインスクリプトがまだ使う。
import './bootstrap'

// AdminLTE 4 本体。サイドバーの開閉・treeview を data-lte-toggle 属性から
// 初期化する。jQuery には依存しないが、Bootstrap 5 の後に評価すること。
import 'admin-lte'

import bootbox from 'bootbox'

// Blade のインラインスクリプトから参照される
import './select_city'

window.bootbox = bootbox

window.chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
}
